import React from 'react'
import './render_utils.scss'

export const renderTermsOfUse = (props, isLogin) => {
  const { t } = props

  const text = t(isLogin ? 'sign_in.terms_of_use_first_half' : 'sign_in.register.terms')
  const links = t('sign_in.terms_of_use_links', { returnObjects: true })

  // Parse the text and replace <0>, <1>, <2> tags with actual links
  const parseTextWithLinks = (text) => {
    const parts = []
    let currentIndex = 0
    const regex = /<(\d+)>([^<]+)<\/\1>/g
    let match

    while ((match = regex.exec(text)) !== null) {
      // Add text before the match
      if (match.index > currentIndex) {
        parts.push(text.substring(currentIndex, match.index))
      }

      // Add the link
      const linkIndex = parseInt(match[1], 10)
      const linkText = match[2]
      let href = ''

      switch (linkIndex) {
      case 0:
        href = links.agreement
        break
      case 1:
        href = links.privacy_policy
        break
      case 2:
        href = links.host_service_agreement
        break
      case 3:
        href = links.host_privacy_policy
        break
      }

      parts.push(
        <a
          key={`link-${linkIndex}-${match.index}`}
          styleName="bl-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkText}
        </a>
      )

      currentIndex = regex.lastIndex
    }

    // Add remaining text
    if (currentIndex < text.length) {
      parts.push(text.substring(currentIndex))
    }

    return parts
  }

  return (
    <div styleName={props.modal.isSocialLoginModalShow ? "social-login-form__note" : "login-form__note"} tx-content="translate_urls">
      <p>{parseTextWithLinks(text)}</p>
      {!isLogin &&
        <p>{t('sign_in.terms_of_use_second_half')}</p>
      }
    </div>
  )
}

export default renderTermsOfUse
